import type { FragmentType } from '@e-socna/data-layer';

import { OrganizationCard } from './OrganizationCard';
import { PersonCard } from './PersonCard';
import type { OrganizationCardCmp_Organization_Fragment } from './OrganizationCard';
import type { PersonCardCmp_Person_Fragment } from './PersonCard';

interface Props {
  readonly organization?: FragmentType<
    typeof OrganizationCardCmp_Organization_Fragment
  >;
  readonly person?: FragmentType<typeof PersonCardCmp_Person_Fragment>;
}

export const ThirdPartyCard = ({ organization, person }: Readonly<Props>) => {
  if (organization) {
    return <OrganizationCard organization={organization} />;
  }

  if (person) {
    return <PersonCard person={person} />;
  }

  throw new Error('Organization or person must be defined');
};
